import { ModelConfigParams, genericApplicationChecklistMFG, genericApplicationChecklistQC } from "./model-config-params";

// https://en.wikipedia.org/wiki/Liver
// https://en.wikipedia.org/wiki/Lobes_of_liver
// https://en.wikipedia.org/wiki/Liver_segment
export const liver: ModelConfigParams = {
  bodyParts: [
    'tumour',
    'arteryWithUncertain',
    'veinWithUncertain',
    'portalVeinWithSegments',
    'cyst',
    'liver',
    'liverLobeLeft',
    'liverLobeRight',
    'biliarySystem',
    'unknown',
  ],
  tissueHotkeys: {
    tumour: 'q',
    artery: 'w',
    vein: 'e',
    portalVein: 'r',
    arteryUncertain: "t",
    veinUncertain: "y",
    cyst: "u",
    liver: "i",
    liverLobeLeft: "o",
    liverLobeRight: "p",
    bileDuct: "alt + q",
    unknown: "alt + w",
  },
  checklist: genericApplicationChecklistMFG,
  checklistQC: genericApplicationChecklistQC,
  defaultIntensityRange: [-100, 250],
}
